import React, { Component } from 'react'

import Header from '../components/header'
import Footer from '../components/footer'
import Nav from '../components/nav'

import '../styles/index.sass'
import ScrollTrack from '../components/scroll-track'
import LinksGrid from '../components/links-grid'

import withRouter from 'react-router-dom/withRouter'
import { TransitionGroup, CSSTransition } from 'react-transition-group'

class TransitionHandler extends React.Component {
  shouldComponentUpdate(nextProps, nextState) {
    return this.props.location.pathname === window.location.pathname
  }

  render() {
    const { children } = this.props
    return <div className="transition-container">{children}</div>
  }
}

class Layout extends Component {
  lastKnownScrollPosition = 0
  isTicking = false
  scrollThreshold = 0
  vieportHeight = 0

  state = {
    isNavVisible:
      typeof location === 'undefined' || location.pathname === '/'
        ? false
        : true,
  }

  componentDidMount() {
    if (window && location) {
      this.vieportHeight = window.innerHeight

      window.addEventListener('scroll', () => {
        this.lastKnownScrollPosition = window.scrollY
        // Imposto la scrollThreshold all'altezza del viewport solo se sono
        // in home. In tutte le altre pagine la nav deve essere sempre visibile
        this.scrollThreshold = location.pathname === '/' ? 10 : 0

        if (!this.isTicking) {
          window.requestAnimationFrame(() => {
            this.checkNavVisibility(this.lastKnownScrollPosition)
            this.isTicking = false
          })

          this.isTicking = true
        }
      })
    }
  }

  checkNavVisibility = scrollPosition => {
    if (scrollPosition >= this.scrollThreshold && !this.state.isNavVisible) {
      return this.setState({ isNavVisible: true })
    }

    if (scrollPosition < this.scrollThreshold && this.state.isNavVisible) {
      this.setState({ isNavVisible: false })
    }
  }

  renderGrid = (location, data) => {
    const locationArray = location.pathname.split('/')
    const currentPage = locationArray[1] === '' ? '/' : locationArray[1]
    const allImages = data.allImageSharp.edges

    const imageMap = {
      agenda: allImages.find(
        image => image.node.sizes.src.indexOf('agenda_base') >= 0
      ),
      agendaHover: allImages.find(
        image => image.node.sizes.src.indexOf('agenda_hover') >= 0
      ),
      pubblicazioni: allImages.find(
        image => image.node.sizes.src.indexOf('pubbl_base') >= 0
      ),
      pubblicazioniHover: allImages.find(
        image => image.node.sizes.src.indexOf('pubblicazioni_hover') >= 0
      ),
      progetto: allImages.find(
        image => image.node.sizes.src.indexOf('progetto_base') >= 0
      ),
      progettoHover: allImages.find(
        image => image.node.sizes.src.indexOf('progetto_hover') >= 0
      ),
      sottoprogetti: allImages.find(
        image => image.node.sizes.src.indexOf('sottoprogetti') >= 0
      ),
      sottoprogettiHover: allImages.find(
        image => image.node.sizes.src.indexOf('sottoprogetti') >= 0
      ),
      gruppoDiRicerca: allImages.find(
        image => image.node.sizes.src.indexOf('splash') >= 0
      ),
      gruppoDiRicercaHover: allImages.find(
        image => image.node.sizes.src.indexOf('splash') >= 0
      ),
    }

    switch (currentPage) {
      case 'progetto':
        return (
          <LinksGrid
            imageMap={imageMap}
            links={[
              'sottoprogetti',
              'agenda',
              'pubblicazioni',
              'gruppoDiRicerca',
            ]}
          />
        )
      case 'agenda':
        return (
          <LinksGrid
            imageMap={imageMap}
            links={[
              'progetto',
              'sottoprogetti',
              'pubblicazioni',
              'gruppoDiRicerca',
            ]}
          />
        )
      case 'pubblicazioni':
        return (
          <LinksGrid
            imageMap={imageMap}
            links={['progetto', 'agenda', 'sottoprogetti', 'gruppoDiRicerca']}
          />
        )
      case 'gruppo-di-ricerca':
        return (
          <LinksGrid
            imageMap={imageMap}
            links={['progetto', 'sottoprogetti', 'pubblicazioni', 'agenda']}
          />
        )
      default:
        return (
          <LinksGrid
            imageMap={imageMap}
            links={[
              'sottoprogetti',
              'agenda',
              'pubblicazioni',
              'gruppoDiRicerca',
            ]}
          />
        )
    }
  }

  render() {
    const { children, location, data } = this.props

    return (
      <div>
        {/* Mostro l'header solo nella home */}
        {location.pathname === '/' && (
          <Header images={data.allImageSharp.edges} />
        )}

        <Nav visible={this.state.isNavVisible} />

        {/* Mostro lo scrollTrack solo nella pagina Progetto */}
        {location.pathname.startsWith('/progetto') && <ScrollTrack />}

        <TransitionGroup>
          <CSSTransition
            key={location.pathname}
            classNames="fadein"
            timeout={{ enter: 200, exit: 100 }}
          >
            <TransitionHandler location={location}>
              <main className="Main">
                {children()}

                {/* Mostro una griglia diversa per ogni pagina */}

                {this.renderGrid(location, data)}
              </main>
            </TransitionHandler>
          </CSSTransition>
        </TransitionGroup>

        <Footer images={data.allImageSharp.edges} />
      </div>
    )
  }
}

export default withRouter(Layout)

export const query = graphql`
  query AllImages {
    allImageSharp {
      edges {
        node {
          sizes {
            base64
            aspectRatio
            src
            srcSet
            sizes
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js